import React, { useState, useEffect } from "react";
import Modal from "../../../../components/modal";

const UnitForm = ({ show, onClose, heading, initialData = {}, onSubmit }) => {
    // State to manage form inputs
    const [formData, setFormData] = useState({
        name: '',
    });

    // Load initial data into form if editing an existing tax
    useEffect(() => {
        if (initialData) {
            setFormData({
                name: initialData.name || '',
            });
        }
    }, [initialData]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group mb-4">
                            <label>Name</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter Unit Name"
                                required
                            />
                        </div>
                    </div>

                    
                </div>

                <div className="d-flex justify-content-end">
                    <button 
                        type="button" 
                        className="btn btn-light me-2" 
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default UnitForm;
